import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AlertCircle } from "lucide-react";

export function ErrorPage() {
  const error = useRouteError();

  // Report non-404 errors to Sentry
  if (!isRouteErrorResponse(error) || error.status !== 404) {
    Sentry.captureException(error);
  }

  let title = "Something went wrong";
  let description = "An unexpected error occurred.";

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = "Page not found";
      description = "The page you're looking for doesn't exist.";
    } else {
      title = `Error ${error.status}`;
      description = error.statusText || description;
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <div className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-destructive" />
            <CardTitle>{title}</CardTitle>
          </div>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent className="flex gap-2">
          <Link to="/" className="flex-1">
            <Button variant="outline" className="w-full">
              Go home
            </Button>
          </Link>
          <Button className="flex-1" onClick={() => window.location.reload()}>
            Refresh
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
